export default {
    props: {
        size: String, // is-small, is-medium, is-large
        loading: Boolean,
        rounded: Boolean,
        icon: String // name of icon
    },
    computed: {
        // find parent with class .field
        parentField() {
            let parent = this.$parent;
            for (let i = 0; i < 3; i++) {
                if (parent && !parent.$data.hasClassField) {
                    parent = parent.$parent;
                }
            }
            return parent;
        },

        // Get the type prop from parent if it's a Field.
        // statusType() {
        //     if (!this.parentField) return;
        //     if (!this.parentField.newType) return;
        //     if (typeof this.parentField.newType === 'string') {
        //         return this.parentField.newType;
        //     }
        // },

        // Get the message prop from parent if it's a Field.
        statusMessage() {
            if (!this.parentField) return;

            return this.parentField.newMessage;
        },

        // fix icon size for inputs
        iconSize() {
            switch (this.size) {
                case 'is-large':
                case 'is-medium':
                    return 'is-medium';
                case 'is-small':
                    return this.size;
            }
        }
    }
};
